import { EoBaseViewComponent } from '../eo-base-view/eo-base-view.component';
import { EoViewComponentTypeEnum } from '../eo-base-view/eo-view-component-type-enum';
import { IViewComponent } from '../eo-base-view/i-view-component';

export class EoViewPanelConfig {
  id?: string;
  name?: string;
  viewComponents?: EoViewComponentDescriptor[];
  classes?: string;
  columnsNum?: number;
}

export class EoViewComponentDescriptor {
  componentType?: EoViewComponentTypeEnum;
  label?: string;
  value?: any;

  // Date View props
  dateFormat?: string;

  // Label View props
  toolTipPosition?: string;
  toolTipText?: string;
  icon?: string;
  severity?: string;

  // Currency View props
  decimalDigits?: number;
  currencyFormat?: string;
}
